<template>
  <div class="plv-iar-red-envelope-qn_modal__bg">

    <div class="plv-iar-red-envelope-qn_modal" :data-lang="lang">
      <div class="plv-iar-red-envelope-qn_modal__relative">
        <div class="plv-iar-red-envelope-qn_modal-bg">
          <img src="./imgs/redpack-qn-top-bg.png" alt=""/>
        </div>
        <div class="plv-iar-red-envelope-qn_modal-close">
          <img src="./imgs/qn-close.png" alt="" @click="closeQuestionnaire"/>
        </div>

        <div class="plv-iar-red-envelope-qn_modal_content">
          <div class="plv-iar-red-envelope-qn_content-header">
            <div class="plv-iar-red-envelope-qn__process-title">
              <span>{{ iarTrans('redEnvelope.question') }}</span>
              <div class="plv-iar-red-envelope-qn__process-value plv-font-din-pro-regular">
                <span v-if="questionnaireData" class="plv-iar-red-envelope-qn__process-current">{{ currentIndex + 1 }}</span>
                <span v-if="questionnaireData" class="plv-iar-red-envelope-qn__process-total">/ {{ questionnaireData.questionCount}}</span>
              </div>

            </div>
            <div v-if="questionnaireData" :key="rightCount">{{ iarTrans('redEnvelope.answerCorrectTip', { num: questionnaireData.correctAnswer }) }}  {{ iarTrans('redEnvelope.questionTip2', { num: rightCount }) }} </div>
          </div>

          <div v-if="currentQuestion" class="plv-iar-red-envelope-question_content">
            <div class="plv-iar-red-envelope-question_content__inner" @scroll="scrollHandle">
              <div class="plv-iar-red-envelope-question_title">
                <span class="plv-iar-red-envelope-qn_type-label" :class="{'plv-iar-red-envelope-qn_type-label--mul': currentQuestion.type === 'C'}">{{questionType(currentQuestion)}}</span>
                <span style="padding-top: 2px;">{{ currentIndex + 1 }}. {{ currentQuestion.title }}</span>
              </div>
              <template v-if="currentQuestion">
                <QuestionItem
                  v-if="!isShowAnswerResult"
                  :class="{'plv-iar-red-envelope-qn-type__mul': currentQuestion.type === 'C'}"
                  :question="currentQuestion"
                  @select="onSelectOption"
                  :key="currentQuestion.id"/>
                <div v-else-if="isShowAnswerResult"
                     class="plv-iar-red-envelope-qn_result"
                     ref="qnResult"
                >
                  <div v-for="(option, index) in currentQuestion.options"
                       :key="index"
                       class="plv-iar-red-envelope-qn__option"
                       :class="{
                         'plv-iar-red-envelope-qn__option--checkbox': currentQuestion.type === 'C',
                         'plv-iar-red-envelope-qn__option--right': isRightOption(index),
                         'plv-iar-red-envelope-qn__option--wrong': isWrongOption(index),
                         'plv-iar-red-envelope-qn__option--selected': isSelectedOption(index),
                       }
                       ">
                    <div>
                      <span class="plv-iar-red-envelope-qn__option--icon"></span>
                      <span v-if="currentQuestion.type ==='R' || currentQuestion.type ==='C'">{{ optionChar(index) }} . </span>
                      <span>{{ option }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="plv-iar-red-envelope-qn__button-group">
              <div :class="{
                'plv-iar-red-envelope-qn__gradient': showGradient
              }"></div>
              <div v-if="isShowAnswerResult"
                   class="plv-iar-red-envelope-qn-result__tip"
              >
                <div>
                  <span style="font-weight: bold; color: #333333;"> {{ iarTrans('redEnvelope.answerLabel')}}</span>
                  <template v-if="isCorrect(answerResult.correctAnswer, answerResult.answer)" >
                    <span style="color: #01B46D;">{{ iarTrans('redEnvelope.answerTip1')}} </span>
                    <span>{{ iarTrans('redEnvelope.answerTip2')}} {{ answerResult.correctAnswer.toLocaleUpperCase() }}</span>
                  </template>
                  <template v-else>
                    <span style="color: #FF3535;">{{ iarTrans('redEnvelope.answerWrong')}}</span>
                    <span>{{ iarTrans('redEnvelope.answerTip2')}} {{ answerResult.correctAnswer.toLocaleUpperCase() }},</span>
                    <span>{{ iarTrans('redEnvelope.answerTip3')}} {{ this.answerResult.answer.toLocaleUpperCase() }}</span>
                  </template>
                </div>
              </div>
              <div v-if="showOpenBtn" class="plv-iar-red-envelope-qn__button plv-iar-red-envelope-qn__button__active" @click="openQnRedEnvelope">
                <span>
                  {{ iarTrans('redEnvelope.open') }}
                </span>
              </div>
              <div v-else
                   class="plv-iar-red-envelope-qn__button"
                   :class="{'plv-iar-red-envelope-qn__button--disabled': disabledBtn}"
                   @click="clickButton">
                {{ btnText }}
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import QuestionItem from '../questionnaire/question/MobileQuestionItem';
import mixin from './mixin';
import { showToast } from '../../assets/utils/toast';
import { optionChar } from '../../assets/utils/utils';
export default {
  name: 'MobileRedEnvelopeQuestionnaire',
  mixins: [mixin],
  components: {
    QuestionItem
  },
  props: {
    redEnvelopeData: {
      type: Object,
      default: () => ({})
    },
    redEnvelopeSdk: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentIndex: 0,
      currentQuestion: null,
      currentAnswer: '', // 当前选中的答案
      questionnaireData: null,
      answerQuestions: [], // 答题结果列表-答案
      answerResult: null, // 用户答题结果
      isShowAnswerResult: false,
      showOpenBtn: false, // 是否展示领取操作
      showGradient: true
    };
  },
  created() {
    this.getQuestionnaireData();
  },
  watch: {
    currentQuestion() {
      const index = this.answerQuestions.findIndex(item => item.questionId === this.currentQuestion.id);
      if (index > -1) {
        this.answerResult = this.answerQuestions[index];
        this.isShowAnswerResult = true;
        this.resultScrollTo();
      } else {
        this.answerResult = null;
        this.isShowAnswerResult = false;
      }
    },
  },
  computed: {
    btnText() {
      if (this.currentQuestion.type !== 'C' && !this.isShowAnswerResult && this.currentIndex === (this.questionnaireData.questions.length - 1)) {
        return this.iarTrans('redEnvelope.open');
      } else if (this.currentQuestion.type === 'C' && !this.isShowAnswerResult) {
        return this.iarTrans('redEnvelope.questionBtn1');
      } else {
        return this.iarTrans('redEnvelope.questionBtn2');
      }
    },
    rightCount() {
      let rightCount = 0;
      // 计算已答对的题数
      this.answerQuestions.forEach(item => {
        if (item.correct === 'Y') {
          rightCount++;
        }
      });
      return rightCount;
    },
    disabledBtn() {
      let status = false;
      // 展示题目结果，可以点击下一题
      if (this.isShowAnswerResult) {
        return status;
      }
      // 单选和判断题，默认禁用， 多选题选中选项后，才可点击。
      if (this.currentQuestion.type === 'R' || this.currentQuestion.type === 'J') {
        status = true;
      }
      if (this.currentQuestion.type === 'C') {
        status = !this.currentAnswer;
      }
      return status;
    }
  },
  methods: {
    optionChar,
    async getQuestionnaireData() {
      const { redpackId, question } = this.redEnvelopeData;
      const { questionGroupId } = question;
      this.questionnaireData = await this.redEnvelopeSdk.getQuestionnaireData({ redpackId, questionGroupId });
      this.answerQuestions = await this.redEnvelopeSdk.getQuestionnaireProcess({ redpackId, questionGroupId });
      this.checkAnswerProcess();
    },
    checkAnswerProcess() {
      // 检查是否完成答题
      this.showOpenBtn = this.answerQuestions.length === this.questionnaireData.questions.length;
      // 当前答题进度，取决于已回答题数
      const answerQuestionsLen = this.answerQuestions.length;
      this.currentIndex = answerQuestionsLen > 0 ? answerQuestionsLen - 1 : 0;
      this.currentQuestion = this.questionnaireData.questions[this.currentIndex];
    },
    async onSelectOption(data) {
      this.currentAnswer = data.answer;
      if (this.currentQuestion.type === 'R' || this.currentQuestion.type === 'J') {
        await this.submitAnswer();
        this.checkAnswerProcess();
      }
    },

    async submitAnswer() {
      const { redpackId, question } = this.redEnvelopeData;
      const { questionGroupId } = question;
      // 答案排序
      const answer = this.currentAnswer.split('').sort().join('');
      const data = {
        redpackId,
        questionGroupId,
        answer: answer,
        questionId: this.currentQuestion.id,
      };
      try {
        const answerQuestion = await this.redEnvelopeSdk.submitQuestionnaireAnswer(data);
        this.answerQuestions.push(answerQuestion);
        this.answerResult = answerQuestion;
        this.isShowAnswerResult = true;
        // 检查是否完成答题
        this.showOpenBtn = this.answerQuestions.length === this.questionnaireData.questions.length;
        this.resultScrollTo();
      } catch (e) {
        showToast({
          text: e.data.error.desc
        });
      }
    },
    async clickButton() {
      if (this.disabledBtn) {
        return;
      }
      if (!this.isShowAnswerResult) {
        await this.submitAnswer();
        return;
      }
      this.nextQuestion();
    },
    nextQuestion() {
      if (this.currentIndex >= this.questionnaireData.questionCount - 1) {
        this.$emit('close');
        return;
      }
      this.currentAnswer = '';
      this.currentIndex++;
      this.currentQuestion = this.questionnaireData.questions[this.currentIndex];
    },
    questionType(question) {
      let typeText = '';
      if (question.type === 'R') {
        typeText = this.iarTrans(`${this.langName}.singleChoice`);
      } else if (question.type === 'C') {
        typeText = this.iarTrans(`${this.langName}.multiChoice`);
      } else if (question.type === 'J') {
        typeText = this.iarTrans(`${this.langName}.judgement`);
      }

      return typeText;
    },

    closeQuestionnaire() {
      this.$emit('close');
    },

    isRightOption(index) {
      return this.answerResult.correctAnswer.toLocaleUpperCase().indexOf(optionChar(index)) > -1;
    },
    isWrongOption(index) {
      const currentOption = optionChar(index);
      const answer = this.answerResult.answer.toLocaleUpperCase();
      const correctAnswer = this.answerResult.correctAnswer.toLocaleUpperCase();
      // 用户答案中包含当前选项，且正确答案中不包含当前选项，即为错误选项
      return answer.indexOf(currentOption) > -1 && correctAnswer.indexOf(currentOption) === -1;
    },
    isSelectedOption(index) {
      const answer = this.answerResult.answer.toLocaleUpperCase();
      return answer.indexOf(optionChar(index)) > -1;
    },
    isCorrect(correctAnswer, answer) {
      return correctAnswer.toLocaleUpperCase() === answer.toLocaleUpperCase();
    },
    openQnRedEnvelope() {
      const correctAnswer = this.questionnaireData.correctAnswer;
      const rightCount = this.rightCount;
      this.$emit('open', { correctAnswer, rightCount });
    },
    scrollHandle(e) {
      // 监听滚动距离底部20px, 隐藏渐变区域
      const isBottom = (e.target.scrollTop + e.target.clientHeight + 20) > e.target.scrollHeight;
      this.showGradient = !isBottom;
    },
    resultScrollTo() {
      this.$nextTick(() => {
        this.$refs.qnResult.scrollTo(0, 1);
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/basic.scss';
// 选项高度
$optionsHeight: auto;

.plv-iar-red-envelope-qn_modal {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  height: 507px;
  z-index: 100;
  .plv-iar-red-envelope-qn_modal-close {
    position: absolute;
    top: 25px;
    right: 25px;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .plv-iar-red-envelope-qn_modal_content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 12px;
    background-image: url('./imgs/redpack-qn-model-bg.png');
    background-size: 100% 100%;

    box-sizing: border-box;
    //background: linear-gradient(90deg, #F65947 0%, #F46751 51%, #F65947 100%);
    //border: 2px solid #FAE4CD;
    //border-bottom: none;
    //box-shadow: inset 0 0 16px 0 #FFA78C;
    .plv-iar-red-envelope-question_content__inner {
      flex: 1;
      overflow: auto;
    }
    .plv-iar-red-envelope-question_content {
      position: relative;
      margin-top: 15px;
      flex: 1;
      background: #FFF6EB;
      padding: 14px 0 80px 14px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .plv-iar-red-envelope-qn-type__mul {
        .plv-iar-questionnaire-question__option__text {
          padding-left: 20px;
        }
        .plv-iar-questionnaire-question__option__inner-wrap {
          position: relative;
        }
        .plv-iar-questionnaire-question__option__mobile--border::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 10px;
          width: 16px;
          height: 16px;
          transform: translate(0, -50%);
          background-size: 100% 100%;
          background-image: url('./imgs/checkBox-unselect.png');
        }
        .plv-iar-questionnaire-question__option__input:checked ~ .plv-iar-questionnaire-question__option__mobile--border::after {
          background-image: url('./imgs/checkBox-selected.png');
        }
      }
      .plv-iar-red-envelope-question_title {
        font-size: 16px;
        padding-right: 14px;
        font-weight: 500;
        line-height: 26px;
        margin-bottom: 16px;
      }
      .plv-iar-red-envelope-qn_type-label {
        display: inline-block;
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        padding: 0 4px;
        background-color: rgb(1 178 107 / 10%);
        border-radius: 3px;
        color: #01B46D;
        margin-right: 4px;
        box-sizing: border-box;
        vertical-align: text-top;
      }
      .plv-iar-red-envelope-qn_type-label--mul {
        background-color: rgb(47 130 254 / 10%);
        color: #3082FE;
      }
      .plv-iar-questionnaire-question__options--table {
        display: block;
      }
      .plv-iar-questionnaire-question-mobile {
        flex: 1;
        overflow: hidden;
        height: $optionsHeight;
      }
      .plv-iar-questionnaire-question__title {
        font-size: 16px;
        padding-right: 14px;
        display: none;
      }
      .plv-iar-questionnaire-question__option {
        margin-right: 14px;
        display: flex;
        flex-direction: column;
      }
      .plv-iar-questionnaire-question__option__inner-wrap {
        label {
          background-color: #FFFFFF;
          border-radius: 8px;
          min-height: 44px;
          line-height: 22px;
          box-sizing: border-box;
        }
      }
      .plv-iar-questionnaire-question__options {
        box-sizing: border-box;
        height: $optionsHeight;
        overflow: auto;
      }
      .plv-iar-questionnaire-question__option__mobile--border {
        border-radius: 8px;
        border: none !important;
      }
      .plv-iar-questionnaire-question__option__text {
        color: #333333;
      }
      .plv-iar-questionnaire-question__option__input:checked ~ .plv-iar-questionnaire-question__option__text {
        color: #333333;
      }
    }
  }
}
.plv-iar-red-envelope-qn_modal__relative {
  position: relative;
  height: 100%;
}
.plv-iar-red-envelope-qn_modal-bg {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translate(-50%, 0);
  img {
    width: 275px;
    height: 100%;
  }
}
.plv-iar-red-envelope-qn_content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
  margin-top: 55px;
}
.plv-iar-red-envelope-qn__process-title {
  display: flex;
  .plv-iar-red-envelope-qn__process-value {
    margin-left: 4px;
    line-height: 18px;
    .plv-iar-red-envelope-qn__process-current {
      font-size: 14px;
    }
  }
}
.plv-iar-red-envelope-qn__button-group {
  position: absolute;
  bottom: 0;
  left: 13px;
  right: 13px;
  background: #FFF6EB;
}
.plv-iar-red-envelope-qn__button {
  z-index: 10;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #FFFFFF;
  font-size: 16px;
  margin-top: 15px;
  border-radius: 25px;
  margin-bottom: 20px;
  background: linear-gradient(98deg, #FF9E63 0%, #FF5031 100%);
  &--disabled {
    opacity: .5;
  }
}
.plv-iar-red-envelope-qn__button__active {
  background: linear-gradient(90deg, #FF7A4C, #FF4FD3, #FF7A4C);
  background-size: 300%;
  z-index: 0;
  animation: ambi 6s linear infinite;
}
@keyframes ambi {
  100% {
    background-position: -300% 0;
  }
}
.plv-iar-red-envelope-qn_result {
  height: $optionsHeight;
  overflow: auto;
  &::-webkit-scrollbar-thumb {
    background: #EB4E27;
  }
}
.plv-iar-red-envelope-qn_result:last-child {
  margin-bottom: 35px;
}
.plv-iar-red-envelope-qn__option {
  line-height: 22px;
  font-size: 14px;
  border-radius: 8px;
  background: #FFFFFF;
  padding: 12px 30px 12px 14px;
  margin-right: 14px;
  position: relative;
}
.plv-iar-red-envelope-qn__option + .plv-iar-red-envelope-qn__option {
  margin-top: 12px;
}
.plv-iar-red-envelope-qn__option--right {
  background: rgba(1, 180, 109, 0.1);
}
.plv-iar-red-envelope-qn__option--wrong {
  background: rgba(255, 53, 53, 0.1);
}
.plv-iar-red-envelope-qn__option--selected.plv-iar-red-envelope-qn__option--right {
  .plv-iar-red-envelope-qn__option--icon::after {
    position: absolute;
    right: 12px;
    top: 50%;
    width: 16px;
    height: 16px;
    transform: translateY(-50%);
    content: ' ';
    background-image: url('./imgs/icon-select-right.png');
    background-size: 100% 100%;
  }
}
.plv-iar-red-envelope-qn__option--selected.plv-iar-red-envelope-qn__option--wrong {
  .plv-iar-red-envelope-qn__option--icon::after {
    position: absolute;
    transform: translateY(-50%);
    right: 12px;
    top: 50%;
    width: 16px;
    height: 16px;
    content: ' ';
    background-image: url('./imgs/icon-select-wrong.png');
    background-size: 100% 100%;
  }
}
.plv-iar-red-envelope-qn__option--checkbox {
  padding-left: 35px;
}
.plv-iar-red-envelope-qn__option--checkbox::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10px;
  width: 16px;
  height: 16px;
  transform: translate(0, -50%);
  background-image: url('./imgs/checkBox-unselect.png');
  background-size: 100% 100%;
}
.plv-iar-red-envelope-qn__option--selected.plv-iar-red-envelope-qn__option--checkbox::after {
  background-image: url('./imgs/checkBox-selected.png');
}

.plv-iar-red-envelope-qn-result__tip {
  font-size: 14px;
  color: #666666;
  margin-top: 12px;
}
.plv-iar-red-envelope-qn__gradient {
  position: relative;
}
.plv-iar-red-envelope-qn__gradient::after {
  content: ' ';
  position: absolute;
  top: -15px;
  left: 0;
  right: 0;
  bottom: 0;
  height: 15px;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgb(255, 246, 235, .8) 20%, #FFF6EB 100%);
}
//.plv-iar-red-envelope-qn_modal__cycle {
//  width: 40px;
//  height: 40px;
//  border-radius: 50%;
//  border: 3px solid #fae4cd;
//}
.plv-iar-red-envelope-qn_modal[data-lang='en'] {
  .plv-iar-red-envelope-qn_content-header {
    font-size: 11px;
  }
}
.plv-iar-red-envelope-qn_modal__bg {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  background: rgb(0 0 0 / 60%);
}
</style>
